// ─── KPI Cards ───────────────────────────────────────────────────────────────
export const kpiCards = [
  {
    id: "open-quotations",
    title: "Open Quotations",
    value: 24,
    comparison: "8% vs last week",
    trend: "up",
    iconType: "quotation",
    iconBg: "#EFF6FF",
    iconColor: "#2563EB",
  },
  {
    id: "jobs-in-progress",
    title: "Jobs in Progress",
    value: 62,
    comparison: "5% vs last week",
    trend: "up",
    iconType: "briefcase",
    iconBg: "#F0FDF4",
    iconColor: "#16A34A",
  },
  {
    id: "active-freight",
    title: "Active Freight",
    value: 78,
    comparison: "11% vs last week",
    trend: "up",
    iconType: "truck",
    iconBg: "#EFF6FF",
    iconColor: "#0EA5E9",
  },
  {
    id: "customs-pending",
    title: "Customs Pending",
    value: 16,
    comparison: "6% vs last week",
    trend: "down",
    iconType: "customs",
    iconBg: "#FFF7ED",
    iconColor: "#EA580C",
  },
  {
    id: "on-hold-exceptions",
    title: "On Hold / Exceptions",
    value: 9,
    comparison: "10% vs last week",
    trend: "down",
    iconType: "warning",
    iconBg: "#FEF2F2",
    iconColor: "#DC2626",
  },
  {
    id: "due-today",
    title: "Due Today",
    value: 21,
    comparison: "Requires Action",
    trend: null,
    iconType: "calendar",
    iconBg: "#F5F3FF",
    iconColor: "#7C3AED",
  },
  {
    id: "jobs-closed-today",
    title: "Jobs Closed Today",
    value: 28,
    comparison: "12% vs last week",
    trend: "up",
    iconType: "check-circle",
    iconBg: "#F0FDF4",
    iconColor: "#16A34A",
  },
];

// ─── Quotation Overview ───────────────────────────────────────────────────────
export const quotationMetrics = [
  { label: "Created", value: 40 },
  { label: "Sent", value: 32 },
  { label: "Accepted", value: 24 },
  { label: "Conversion Rate", value: "75%" },
];

export const quotationChartData = [
  { date: "10 May", value: 14 },
  { date: "11 May", value: 22 },
  { date: "12 May", value: 18 },
  { date: "13 May", value: 21 },
  { date: "14 May", value: 27 },
  { date: "15 May", value: 19 },
  { date: "16 May", value: 30 },
];

export const quotationExpiry = [
  { label: "Expiring Today", value: 5, color: "#EA580C" },
  { label: "Expiring in 3 Days", value: 7, color: "#D97706" },
  { label: "Expired", value: 3, color: "#DC2626" },
];

// ─── Job Order Status (Donut) ─────────────────────────────────────────────────
export const jobOrderStatuses = [
  { label: "New", count: 8, percent: 13, color: "#2563EB" },
  { label: "In Progress", count: 22, percent: 35, color: "#16A34A" },
  { label: "Pending Customs", count: 9, percent: 15, color: "#EA580C" },
  { label: "In Transit", count: 15, percent: 24, color: "#8B5CF6" },
  { label: "Ready to Close", count: 4, percent: 6, color: "#D97706" },
  { label: "Closed", count: 4, percent: 6, color: "#94A3B8" },
];

// ─── Operations at a Glance ───────────────────────────────────────────────────
export const operationsGlance = [
  { label: "Freight Booking Pending", value: 12, iconType: "booking", color: "#2563EB" },
  { label: "Cargo Awaiting Pickup", value: 7, iconType: "pickup", color: "#2563EB" },
  { label: "In Transit", value: 78, iconType: "transit", color: "#0EA5E9" },
  { label: "Arriving Today", value: 6, iconType: "arriving", color: "#2563EB" },
  { label: "Delayed Freight", value: 8, iconType: "delayed", color: "#DC2626" },
  { label: "Delivered", value: 52, iconType: "delivered", color: "#16A34A" },
];

// ─── Customs Clearance ────────────────────────────────────────────────────────
export const customsClearance = [
  { label: "Pending Clearance", value: 16, iconType: "pending", color: "#EA580C" },
  { label: "Documents Pending", value: 5, iconType: "documents", color: "#DC2626" },
  { label: "Under Assessment", value: 4, iconType: "assessment", color: "#D97706" },
  { label: "Query Raised", value: 3, iconType: "query", color: "#EA580C" },
  { label: "Inspection Pending", value: 2, iconType: "inspection", color: "#D97706" },
  { label: "Cleared Today", value: 7, iconType: "cleared", color: "#16A34A" },
];

// ─── Shipment Milestones ──────────────────────────────────────────────────────
export const shipmentMilestones = [
  { label: "Booking", current: 12, total: 90, percent: 13, iconType: "calendar", color: "#2563EB", bgColor: "#EFF6FF" },
  { label: "Pickup", current: 25, total: 90, percent: 28, iconType: "truck", color: "#0EA5E9", bgColor: "#E0F2FE" },
  { label: "Docs Complete", current: 38, total: 90, percent: 42, iconType: "document", color: "#16A34A", bgColor: "#F0FDF4" },
  { label: "Customs", current: 16, total: 90, percent: 18, iconType: "customs-user", color: "#2563EB", bgColor: "#EFF6FF" },
  { label: "Departure", current: 45, total: 90, percent: 50, iconType: "airplane", color: "#0EA5E9", bgColor: "#E0F2FE" },
  { label: "Arrival", current: 32, total: 90, percent: 36, iconType: "location", color: "#EA580C", bgColor: "#FFF7ED" },
  { label: "Delivery", current: 52, total: 90, percent: 58, iconType: "delivery", color: "#7C3AED", bgColor: "#F5F3FF" },
];

// ─── Action Required ──────────────────────────────────────────────────────────
export const actionRequiredItems = [
  { id: 1, label: "Customs clearance delayed > 24 hrs", count: 5, severity: "critical", iconType: "alert-triangle" },
  { id: 2, label: "Shipments approaching SLA breach", count: 4, severity: "warning", iconType: "alert-sla" },
  { id: 3, label: "Jobs missing documents", count: 6, severity: "warning", iconType: "missing-doc" },
  { id: 4, label: "Freight bookings pending", count: 3, severity: "warning", iconType: "truck-pending" },
  { id: 5, label: "Quotations expiring today", count: 6, severity: "warning", iconType: "expiring" },
  { id: 6, label: "Jobs ready for closure", count: 8, severity: "success", iconType: "ready-close" },
];

// ─── Today's Operations ───────────────────────────────────────────────────────
export const todayOperations = [
  { id: 1, label: "Jobs Created", value: 12, iconType: "document", iconBg: "#EFF6FF", iconColor: "#2563EB" },
  { id: 2, label: "Freight Booked", value: 9, iconType: "truck", iconBg: "#E0F2FE", iconColor: "#0EA5E9" },
  { id: 3, label: "Customs Cleared", value: 8, iconType: "customs-user", iconBg: "#FFF7ED", iconColor: "#EA580C" },
  { id: 4, label: "Shipments Departed", value: 11, iconType: "airplane", iconBg: "#F0F9FF", iconColor: "#0284C7" },
  { id: 5, label: "Shipments Arrived", value: 9, iconType: "location", iconBg: "#FEF3C7", iconColor: "#D97706" },
  { id: 6, label: "Jobs Closed", value: 34, iconType: "check-circle", iconBg: "#F0FDF4", iconColor: "#16A34A" },
];

// ─── Recent Activity ──────────────────────────────────────────────────────────
export const recentActivities = [
  { id: 1, description: "Job ORD-250516-012 customs clearance completed", time: "10:30 AM", iconType: "customs-done", iconColor: "#16A34A", iconBg: "#F0FDF4" },
  { id: 2, description: "Shipment SHP-250516-078 departed", time: "09:45 AM", iconType: "airplane", iconColor: "#0EA5E9", iconBg: "#E0F2FE" },
  { id: 3, description: "New quotation QUO-250516-021 created", time: "09:20 AM", iconType: "quotation", iconColor: "#2563EB", iconBg: "#EFF6FF" },
  { id: 4, description: "Job ORD-250516-064 marked as closed", time: "08:50 AM", iconType: "check-circle", iconColor: "#16A34A", iconBg: "#F0FDF4" },
  { id: 5, description: "Document uploaded for ORD-250516-055", time: "08:15 AM", iconType: "document", iconColor: "#7C3AED", iconBg: "#F5F3FF" },
];
